import { VariantProps } from 'class-variance-authority'

import { buttonVariants } from '@frame/ui-primitives/button'

import { DataAttribute } from '@frame/types'

import { VerifierRequirements } from './api/client-session/types'
import { IncomeType } from './types'

export const TW_EMAIL = 'support@truework.com'
export const TW_PHONE = '1-833-878-3967'

/**
 * Logo.dev API configuration
 * Public key is hardcoded here for all environments (local, CI, production).
 * This is a public key (pk_ prefix), not a secret - safe for client-side use.
 * To generate a new key, visit: https://www.logo.dev/dashboard/api-keys
 */
export const LOGODEV_PUBLIC_KEY = 'pk_fYJQYBLhRImog5Q9AQ5QEQ'

/**
 * Builds a Logo.dev URL for a given domain with optional size parameter
 * @param domain - The domain name (e.g., 'stripe.com' or 'www.stripe.com')
 * @param size - Optional size parameter for the logo
 * @returns The complete Logo.dev URL with token parameter
 */
export function buildLogoDevUrl(domain: string, size?: number): string {
  if (!domain) return ''
  const cleanDomain = domain
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0]
    .split('?')[0]
  const baseUrl = `https://img.logo.dev/${cleanDomain}`
  const params = new URLSearchParams()
  if (size) {
    params.append('size', size.toString())
  }
  params.append('token', LOGODEV_PUBLIC_KEY)
  return `${baseUrl}?${params.toString()}`
}

export const INCOME_CARD_CONFIG = {
  [IncomeType.EMPLOYED]: {
    title: 'Employed income',
    desc: "Select this if you're working for an employer and receive paystubs.",
    button: {
      text: 'Add employer income',
      variant: 'primary' as VariantProps<typeof buttonVariants>['intent'],
    },
    dataCy: DataAttribute.BTN_ADD_EMPLOYED_INCOME,
  },
  [IncomeType.OTHER]: {
    title: 'Other income',
    desc: 'Select this if your income comes from self-employed, disabled, retired, guarantor, child support, alimony, or any other sources.',
    button: {
      text: 'Add other income',
      variant: 'secondary' as VariantProps<typeof buttonVariants>['intent'],
    },
    dataCy: DataAttribute.BTN_ADD_OTHER_INCOME,
  },
}

export const NO_ARGYLE_ITEM_ID_FOUND_IDENTIFIER = 'unknown'

export const verifierRequirementsMapping: Record<VerifierRequirements, string> = {
  [VerifierRequirements.EMPLOYMENT_2_YEARS]: 'the past 2 years of income to verify',
  [VerifierRequirements.EMPLOYMENT_3_YEARS]: 'the past 3 years of income to verify',
  [VerifierRequirements.INCOME_CURRENT]: 'your current source(s) of income',
}

export const addEmploymentMapping: Record<VerifierRequirements, string> = {
  [VerifierRequirements.EMPLOYMENT_2_YEARS]: 'the past 2 years of income',
  [VerifierRequirements.EMPLOYMENT_3_YEARS]: 'the past 3 years of income',
  [VerifierRequirements.INCOME_CURRENT]: 'your current source(s) of income',
}
